import React from 'react';
import { Route, Switch } from 'react-router-dom';
import config from 'config';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';

import '../../modules/emergencies/components/ui/emergencyPopup.css';
import { DashboardPage, ConfigProvider, AlianzaTranslationsProvider } from '@ontruck/fe-alianza';
import { TicketRouterPage } from './ticket-router-page';

function CopilotModule({ match, intl }) {
  const token = useSelector((state) => state?.user?.access_token);

  const alianzaConfig = {
    apiBase: `${config.BASE_URL}`,
    token,
  };

  // Get Alianza translations from Mercury's intl context
  const alianzaTranslations = intl.messages.modules.Alianza || {};

  return (
    <ConfigProvider apiBase={alianzaConfig.apiBase} token={alianzaConfig.token}>
      <AlianzaTranslationsProvider translations={alianzaTranslations}>
        <Switch>
          <Route exact path={match?.url}>
            <DashboardPage config={alianzaConfig} />
          </Route>
          <Route exact path={`${match?.url}/tickets/:id`}>
            <TicketRouterPage config={alianzaConfig} />
          </Route>
        </Switch>
      </AlianzaTranslationsProvider>
    </ConfigProvider>
  );
}

export default injectIntl(CopilotModule);
